import { Img, Modal, ModalOverlay, ModalBody, ModalContent, ModalCloseButton } from '@chakra-ui/react'
import { useWindowSize } from '@/hooks/useWindowSize'

type Props = {
  imageUrl?: string
  onClose: () => void
}

export const ImagePopup = ({ imageUrl, onClose }: Props) => {
  const { height } = useWindowSize()
  return (
    <Modal onClose={onClose} isCentered size={'3xl'} isOpen={imageUrl !== undefined}>
      <ModalOverlay>
        <ModalCloseButton color={'white'} fontSize={'lg'} top={6} right={6} />
      </ModalOverlay>
      <ModalContent borderRadius={'md'} w={'auto'}>
        <ModalBody p={0}>
          <Img borderRadius={'md'} objectFit={'contain'} maxH={height - 200} src={imageUrl} />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
